import React, { useEffect, useState, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import numeral from 'numeral'

const TaxValuesByLotType = (props) => {
	const columns = [
		{
			Header: "Property",
			accessor: "property",
			filterMethod: (f, r) => helpers.tableText(f, r, "property"),
		},
		{
			Header: "Lot Type",
			accessor: "lot_type",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "Low End",
			accessor: "low_end",
			filterMethod: (f, r) => helpers.tableText(f, r, "low_end"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "low_end", "$0,0"),
		},
		{
			Header: "High End",
			accessor: "high_end",
			filterMethod: (f, r) => helpers.tableText(f, r, "high_end"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "high_end", "$0,0"),
		},
		{
			Header: "Average",
			accessor: "average",
			filterMethod: (f, r) => helpers.tableText(f, r, "average"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "average", "$0,0"),
		},
		{
			Header: "Median",
			accessor: "median",
			filterMethod: (f, r) => helpers.tableText(f, r, "median"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableAverages(props, "median", "$0,0"),
		},
		{
			Header: "Count",
			accessor: "count",
			filterMethod: (f, r) => helpers.tableText(f, r, "count"),
			Cell: (props) => numeral(props.value).format("0,0"),
			Footer: (props) => helpers.tableTotals(props, "count", "0,0"),
		},
		{
			Header: "Grand Total",
			accessor: "grand_total",
			filterMethod: (f, r) => helpers.tableText(f, r, "grand_total"),
			Cell: (props) => numeral(props.value).format("$0,0"),
			Footer: (props) => helpers.tableTotals(props, "grand_total", "$0,0"),
		},
	]

	const buildData = () => {
		let ret = []
		let store = {}
		const median = (arr) => arr.sort((a, b) => a - b)[Math.floor(arr.length / 2)]
		_.forEach(props.payload.exec.lots, (v) => {
			if (v.cad_land_value && v.cad_building_value) {
				if (!_.has(store, `${v.property}.${v.lot_type}`)) {
					_.setWith(
						store,
						`${v.property}.${v.lot_type}`,
						{
							low_end: 0,
							high_end: 0,
							average: 0,
							median: 0,
							count: 0,
							grand_total: 0,
							tracker: []
						},
						Object
					)
				}
				store[v.property][v.lot_type].count++
				store[v.property][v.lot_type].grand_total += v.cad_land_value + v.cad_building_value
				let totalValue = v.cad_land_value + v.cad_building_value
				if(store[v.property][v.lot_type].low_end === 0 || totalValue < store[v.property][v.lot_type].low_end) {
					store[v.property][v.lot_type].low_end = totalValue
				}
				if(totalValue > store[v.property][v.lot_type].high_end) {
					store[v.property][v.lot_type].high_end = totalValue
				}
				store[v.property][v.lot_type].average += totalValue
				store[v.property][v.lot_type].tracker.push(totalValue)
			}
		})
		//console.log(store)
		_.forEach(store, (v, property) => {
			_.forEach(v, (vv, lot_type) => {
				let p = _.find(props.payload.public.properties, { id: parseInt(property) })
				let lt = _.find(props.payload.public.lot_types, { id: parseInt(lot_type) })
				ret.push({
					property: p?.name || "",
					lot_type: lt?.name || "",
					low_end: vv.low_end,
					high_end: vv.high_end,
					average: Math.round(vv.average / vv.count),
					median: median(vv.tracker),
					count: vv.count,
					grand_total: vv.grand_total,
				})
			})
		})

		return ret
	}
	let check = buildData()
	if(check.length === 0) {
		return ""
	}
	return (
		<div>
			<h2>Tax Values by Lot Type</h2>
			<p className="text-xs mt-2">Please note these land and building values come directly from the CAD.  Some lots may be missing from the district.  Building values are representative of the current construction status and value of a home. In order for a lot to make it to this table, the lot needs both it's land value and building value to be greater than $0.</p>
			<FullTable
				data={buildData()}
				columns={columns}
				name="taxValuesByLotType"
				title="Tax Values by Lot Type"
				classNames="small"
			/>
		</div>
	)
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(TaxValuesByLotType)
